<!--
 * @Author: wangzhu10 wangzhu10@jd.com
 * @Date: 2022-06-30 15:53:17
 * @LastEditors: wangzhu10 wangzhu10@jd.com
 * @LastEditTime: 2022-10-17 11:03:19
-->
<template>
  <div class="fans-wrapper">
    <div v-title :data-title="fansType ? '我的粉丝' : '我的关注'"></div>
    <div class="erp-list">
      <van-pull-refresh
        v-if="fansList.length || loading"
        v-model="refreshing"
        @refresh="onRefresh"
        success-text="刷新成功">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
          style="margin-top:10px;padding-bottom:50px;"
        >
        <div v-for="(item, index) in fansList" :key="index">
          <div class="list-item">
            <div style="display:flex;">
              <van-image
                @click="handlePersonal(fansType ? item.fansId : item.followId)"
                round
                width="1rem"
                height="1rem"
                class="item-avatar"
                :src="item.avatar"
              />
              <div class="item-info" @click="handlePersonal(fansType ? item.fansId : item.followId)">
                <div>
                  <span>{{item.erpName}}</span>
                </div>
                <div class="label item-org">{{item.erp}}</div>
              </div>
            </div>
            <van-button
              @click="handleAttention(item)"
              class="attentionBtn"
              size="small"
              :type="!fansType ? 'default' : item.isFollowStatus ? 'default' : 'info'">
              {{!fansType ? '已关注' : item.isFollowStatus ? '已关注' : '关 注'}}
            </van-button>
          </div>
          <van-divider />
        </div>
        </van-list>
      </van-pull-refresh>
      <van-empty
        v-else
        :description="!fansType ? '暂无关注' : '暂无粉丝'" />
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import api from '../../api'

export default {
  data() {
    return {
      pageParams: {
        page: 1,
        pageSize: 15
      },
      fansList: [],
      loading: false,
      finished: false,
      refreshing: false,
      fansType: this.$route.query.type === 'fans'
    }
  },
  created() {
    this.fetchFansList()
    this.handleBack()
  },
  methods: {
    handleBack() {
      const _this = this
      let options = {
          disabled: true,
          callback: function() {
            _this.$router.go(-1)
          }
      }
      window.jme.browser.setGoBackDisabled(options)
    },
    fetchFansList() {
      this.loading = true
      const { id } = this.$route.query
      let apiUrl = this.fansType ? api.getFansList : api.getFollowList
      apiUrl({
        ...this.pageParams,
        userId: id 
      }).then(res => {
        this.loading = false
        const { code, data, totalCount } = res
        if (this.refreshing) {
          this.refreshing = false
        }
        if (code === 200) {
          if (this.pageParams.page > 1) {
            this.fansList = this.fansList.concat(data)
          } else {
            this.fansList = data
          }
          if (this.fansList.length >= totalCount) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageParams.page++
      this.fetchFansList()
    },
    onRefresh() {
      this.finished = false
      this.pageParams.page = 1 
      this.fetchFansList()
    },
    handleAttention(item) {
      if (!this.fansType) {
        api.cancelFollow(item.followId).then((res) => {
          if (res.code === 200) {
            Toast.success('取消关注成功')
            this.fetchFansList()
          }
        })
      } else {
        if (item.isFollowStatus) {
          api.cancelFollow(item.fansId).then((res) => {
            if (res.code === 200) {
              Toast.success('取消关注成功')
              this.fetchFansList()
            }
          })
          return
        }
        api.follow(item.fansId).then((res) => {
          if (res.code === 200) {
            Toast.success('关注成功')
            this.fetchFansList()
          }
        })
      }
    },
    handlePersonal(id) {
      if (id === -1) return;
      this.$router.push({ name: 'personal', query: { id } })
    }
  }
}
</script>

<style lang="less" scoped>
.fans-wrapper {
  padding: 20px 10px;
  background: #fff;
  min-height: 100vh;
  z-index: 10;
  font-size: 14px;
  /deep/ .van-pull-refresh {
    user-select: text;
    -webkit-user-select: text;
  }
  .list-item {
    display: flex;
    padding: 5px 20px;
    text-align: left;
    justify-content: space-between;
    align-items: center;
  }
  .item-info {
    margin-left: 10px;
  }
  .item-avatar {
    flex-shrink: 0;
  }
  .ellip {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 85%;
  }
  .label {
    color: #606266;
  }
  .item-org {
    font-size: 12px;
  }
  /deep/ .van-divider {
    margin: 10px;
  }
  .attentionBtn {
    // width: 54px;
    padding: 0 12px;
    height: 24px;
    border-radius: 12px;
    // background: #4783F7;
  }
}
</style>
